export class FileResponse {
	name: string;
	type: string;
	blob: Blob;
}
